import { getId } from '@/helpers';

export const openedDetails = {
  methods: {
    highlightOpenedProposals(item, type) {
      // eslint-disable-next-line no-underscore-dangle
      if (item && type === 'row' && item._showDetails) {
        return 'table-info';
      }
      return '';
    },
    handleDetailsShowing(row) {
      row.toggleDetails();
      if (this.proposalsFromProp) {
        const index = this.proposalsFromProp.findIndex(
          (proposal) => getId(proposal) === getId(row.item),
        );
        this.$set(this.proposalsFromProp, index, row.item);
        this.$emit('update-proposal', row.item);
      }
    },
  },
};
